module.exports = __webpack_public_path__ + "media/images/logos/indeed-f093c803ad2b72a7383a06c0c2d86aa0.svg";